import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, retry, map, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { TicketAirlineProperties, TicketIssuanceProperties, TicketPnrRights } from '../Models/TicketIssuanceProperties';
import { BookingInfoProperties, MealAirArabiaProperties, PassengerCreationResponse, RateOfExchangeRequestProp, RateOfExchangeResponse } from '../Models/BookingPassengerTicketIssuanceProperties';
import { PassengerFares } from '../Models/FlightSearchResponseProperties';
import { ImportPnrDetails } from '../Models/ImportPnrProperties';
@Injectable({
  providedIn: 'root'
})
export class TicketIssuanceService {
  baseUrl = environment.baseUrl;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }
  public showSpinner: BehaviorSubject<boolean> = new BehaviorSubject(false);
  myoptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
    observe: 'response' as 'body',
    responseType: 'blob' as 'blob'
  };
  constructor(private http: HttpClient) { }

  DownloadFile(relatedDocID: number, docName: string): Observable<any> {
    //console.log(relatedDocID);

    return this.http.get(this.baseUrl + '/CmsLogin/DownloadFile/' + relatedDocID, this.myoptions)
      .pipe(map((resObj: Blob) => { return resObj; })
        , catchError(error => {
          return throwError(error);
        }))
  }
  PIAANCIAvailiability(obj): Observable<MealAirArabiaProperties> {
    return this.http.post<MealAirArabiaProperties>(this.baseUrl + '/TicketIssuance/PIAANCIAvailiability', obj, this.httpOptions)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }

  getBookingInfo(ticketReqObj): Observable<TicketIssuanceProperties> {
    return this.http.post<TicketIssuanceProperties>(this.baseUrl + '/TicketIssuance/GetBookingInfo', JSON.stringify(ticketReqObj), this.httpOptions)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  RefundOnlineTicket(TicketProp): Observable<PassengerCreationResponse> {
    return this.http.post<boolean>(this.baseUrl + '/FlightSearch/RefundTicket', TicketProp, this.httpOptions).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }

  getAirlinesByCarrierCode(str): Observable<TicketAirlineProperties[]> {
    return this.http.get<TicketAirlineProperties[]>(this.baseUrl + '/TicketIssuance/GetAirlinesByCarrierCode/' + str).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }

  //getBeneficiaryByNo(accountNo: string): Observable<BeneficiaryAccountProperties[]> {
  //  return this.http.get<BeneficiaryAccountProperties[]>(this.baseUrl + '/BeneficiaryAccount/GetBeneficiaryByAccountNo/' + accountNo)
  //    .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  //}
  CheckTktPnrRightsAgainstAgencyAndUserId(isAgency, param): Observable<TicketPnrRights> {
    return this.http.get<TicketPnrRights>(this.baseUrl + '/TicketIssuance/GetTicketPnrRights/' + isAgency + "/" + param)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

  CheckTktPnrRightsAgainstBooking(isAgency, param, bookingID): Observable<TicketPnrRights> {
    return this.http.get<TicketPnrRights>(this.baseUrl + '/TicketIssuance/CheckTktPnrRightsAgainstBooking/' + isAgency + "/" + param + "/" + bookingID)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  CheckTktPnrRightsAgainstBookingForImportPnr(isAgency, param, bookingID,issuancePcc): Observable<TicketPnrRights> {
    return this.http.get<TicketPnrRights>(this.baseUrl + '/TicketIssuance/CheckTktPnrRightsAgainstBookingForImportPnr/' + isAgency + "/" + param + "/" + bookingID + "/" + issuancePcc)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  IssueGalileoTicket(bookingEmailObj): Observable<PassengerCreationResponse> {
    return this.http.post<boolean>(this.baseUrl + '/FlightSearch/IssueGalileoFlight', bookingEmailObj, this.httpOptions).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }

  RepriceGalileoTicket(bookingEmailObj): Observable<PassengerCreationResponse> {
    return this.http.post<boolean>(this.baseUrl + '/FlightSearch/RepricePNR', bookingEmailObj, this.httpOptions).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }

  PostInvoiceForBranchesStaff(bookingEmailObj): Observable<PassengerCreationResponse> {
    return this.http.post<boolean>(this.baseUrl + '/FlightSearch/PostInvoiceForBranchesStaff', bookingEmailObj, this.httpOptions).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }

  PostInvoiceForTicketsIssuedOfflineImportedThroughImportPnr(bookingEmailObj): Observable<PassengerCreationResponse> {
    return this.http.post<boolean>(this.baseUrl + '/ERPBackOffice/PostInvoiceForTicketsIssuedOfflineImportedThroughImportPnr', bookingEmailObj, this.httpOptions).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  GetTicketBalanceLimitForTicketsIssuedOfflineImportedThroughImportPnr(bookingEmailObj): Observable<PassengerCreationResponse> {
    return this.http.post<boolean>(this.baseUrl + '/ERPBackOffice/GetTicketBalanceLimitForTicketsIssuedOfflineImportedThroughImportPnr', bookingEmailObj, this.httpOptions).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  CancelGalileoPNR(bookingEmailObj): Observable<PassengerCreationResponse> {
    return this.http.post<boolean>(this.baseUrl + '/FlightSearch/CancelPNR', bookingEmailObj, this.httpOptions).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }

  VoidGalileoTicket(voidTicketProp): Observable<PassengerCreationResponse> {
    return this.http.post<boolean>(this.baseUrl + '/FlightSearch/VoidTicket', voidTicketProp, this.httpOptions).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }

  RefundOfflineRequest(obj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/TicketIssuance/UpdateRefundOfflineStatus', obj, this.httpOptions).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  VoidOfflineRequest(obj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/TicketIssuance/UpdateVoidOfflineStatus', obj, this.httpOptions).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  ApproveOfflineRefundRequest(obj): Observable<boolean> {

    this.showSpinner.next(true);
    return this.http.post<boolean>(this.baseUrl + '/TicketIssuance/UpdateChargesOfRefundRequest', obj, this.httpOptions)
      .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)));
  }
  RejectOfflineRefundRequest(obj): Observable<boolean> {

    this.showSpinner.next(true);
    return this.http.post<boolean>(this.baseUrl + '/TicketIssuance/RejectRefundRequest', obj, this.httpOptions)
      .pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)));
  }

  offlineTicketIssuance(ticketReqObj): Observable<BookingInfoProperties> {
    return this.http.post<BookingInfoProperties>(this.baseUrl + '/TicketIssuance/OfflineTicketIssuance', ticketReqObj, this.httpOptions)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  ConfirmOfflineTicketIssuance(ticketReqObjConfim): Observable<PassengerCreationResponse> {
    return this.http.post<PassengerCreationResponse>(this.baseUrl + '/TicketIssuance/UpdateBookingInfoRecord', ticketReqObjConfim, this.httpOptions)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  RemoveSectorInformation(removeSector): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/TicketIssuance/RemoveSectorInformation', removeSector, this.httpOptions)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  RemovePassengerInformation(passengerId): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/TicketIssuance/RemovePassengerInformation', passengerId, this.httpOptions)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  RemovePassengerEmirates(passengerId): Observable<PassengerCreationResponse> {
    return this.http.post<boolean>(this.baseUrl + '/TicketIssuance/RemovePassengerEmirates', passengerId, this.httpOptions)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }

  public GetRateOfExchangeOffline=(rateOfExchangeRequest:RateOfExchangeRequestProp):Observable<RateOfExchangeResponse>=>{
    return this.http.post<RateOfExchangeResponse>(this.baseUrl+'/TicketIssuance/GetRateOfExchangeOffline',rateOfExchangeRequest, this.httpOptions)
    .pipe(map((data:RateOfExchangeResponse)=>{
      return data;
    }),catchError(error=>{return throwError(error)}));
  }


  GetPNRByID(value, agencyId, UserId): Observable<ImportPnrDetails> {
    return this.http.get<ImportPnrDetails>(this.baseUrl + '/ImportPNR/GetImportPnrByID/' + value + "/" + agencyId + "/" + UserId).pipe(map((data: any) => {
      return data;
    }), catchError(error => { return throwError(error); }))
  }
  public CheckRevenueOnSupplierChange = (bookingInfoForSupplierChange: BookingInfoProperties): Observable<BookingInfoProperties> => {
    return this.http.post<BookingInfoProperties>(this.baseUrl + '/TicketIssuance/CheckRevenueOnSupplierChangeOffline', bookingInfoForSupplierChange, this.httpOptions)
      .pipe(map((data: BookingInfoProperties) => {
        return data;
      }), catchError(error => { return throwError(error) }));
  }

  ConfirmOfflineImportTicketIssuance(ticketReqObjConfim): Observable<PassengerCreationResponse> {
    return this.http.post<PassengerCreationResponse>(this.baseUrl + '/ImportPNR/UpdateBookingInfoRecord', ticketReqObjConfim, this.httpOptions)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
}
